import type { SVGProps } from "react";

/**
 * Guest / anonymous user mark for public chatbot rows — white silhouette on the
 * parent’s blue circle (same idea as a generic profile chip, not initials “U”).
 */
export function PublicGuestAvatarIcon({
  size = 20,
  className,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...rest}
    >
      <circle
        cx="12"
        cy="8.25"
        r="3.35"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinejoin="round"
      />
      <path
        d="M4.25 20.25c0-3.35 2.85-6.1 7.75-6.1s7.75 2.75 7.75 6.1"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
